import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import "./DtlTemplateNew.css";
import { toast } from "react-toastify";
import { formatGermanFixedBy2 } from "../../../utility/NumberFormat";

const DtlTemplateNew = (props) => {
  const { singleData, isRequired, detailDiv, setDetailDiv } = props;
  // console.log("props>>>>>>>>>>", singleData)

  const [totals, setTotals] = useState({
    UmsatzTotal: 0,
    AbschriftenTotal: 0,
    KolPlanTotal: 0,
    NosReorderTotal: 0,
    NosVororderTotal: 0,
    GrandTotal: 0,
  });

  const [toastIds, setToastIds] = useState({});

  // const [detailDiv, setDetailDiv] = useState({
  //   companyId: "",
  //   planYear: "",
  //   planMonth: [
  //     "January",
  //     "February",
  //     "March",
  //     "April",
  //     "May",
  //     "June",
  //     "July",
  //     "August",
  //     "September",
  //     "October",
  //     "November",
  //     "December",
  //   ],
  //   division: "",
  //   distributor: "",
  //   area: "",
  //   vtrGroup: "",
  //   soldTo: "",
  //   deliveryId: "",
  //   umsatzAnteile: Array(12).fill(""),
  //   abschriftenAnteilePct: Array(12).fill(""),
  //   kollVoorderPct: Array(12).fill(""),
  //   nosVororderPct: Array(12).fill(""),
  //   nosNachorderPct: Array(12).fill(""),
  // });

  useEffect(() => {
    const DTLValue = singleData?.dtl;
    // console.log("DTLValue",DTLValue)

    if (Array.isArray(DTLValue) && DTLValue.length > 0) {
      setDetailDiv((prev) => ({
        ...prev,

        umsatzAnteile: DTLValue.map((item) => item.umsatzAnteile || ""),
        abschriftenAnteilePct: DTLValue.map(
          (item) => item.abschriftenAnteilePct || ""
        ),
        kollVoorderPct: DTLValue.map((item) => item.kollVoorderPct || ""),
        nosVororderPct: DTLValue.map((item) => item.nosVororderPct || ""),
        nosNachorderPct: DTLValue.map((item) => item.nosNachorderPct || ""),
      }));
    } else {
      setDetailDiv({
        companyId: "",
        planYear: "",
        planMonth: [
          "Januar",
          "Februar",
          "März",
          "April",
          "Mai",
          "Juni",
          "Juli",
          "August",
          "September",
          "Oktober",
          "November",
          "Dezember",
        ],
        division: "",
        distributor: "",
        area: "",
        vtrGroup: "",
        soldTo: "",
        deliveryId: "",
        umsatzAnteile: Array(12).fill(""),
        abschriftenAnteilePct: Array(12).fill(""),
        kollVoorderPct: Array(12).fill(""),
        nosVororderPct: Array(12).fill(""),
        nosNachorderPct: Array(12).fill(""),
      });
    }
  }, [singleData]);

  useEffect(() => {
    if (props?.hdrValue) {
      const updatedState = {
        ...detailDiv,
        companyId: props.hdrValue.companyId || "",
        planYear: props.hdrValue.planYear || "",
        division: props.hdrValue.division || "",
        distributor: props.hdrValue.distributor || "",
        area: props.hdrValue.area || "",
        vtrGroup: props.hdrValue.vtrGroup || "",
        soldTo: props.hdrValue.soldTo || "",
        deliveryId: props.hdrValue.deliveryId || "",
      };
      // console.log('if use effect done', updatedState)
      setDetailDiv(updatedState);
      if (props.onDataChange) {
        props.onDataChange(updatedState);
      }
    }
  }, [props.hdrValue]);

  const validationRules = {

    DTP: {
      default: /^\d{0,3}([.,]\d{0,1})?$/,
    },
  };

  const getThridDiv = (e, index) => {
    const { name, value } = e.target;

    let cleanedValue = value;

    // convert dot decimal to comma decimal
    cleanedValue = cleanedValue.replace(".", ",");

    // support ",5" => "0,5"
    if (cleanedValue.startsWith(",")) {
      cleanedValue = "0" + cleanedValue;
    }

    const rule =
      validationRules?.["DTP"]?.[name] || validationRules?.["DTP"]?.default;

    if (rule && !rule.test(cleanedValue)) return;

    let arrayKey = "";

    if (name === "Umsatzamteilin") arrayKey = "umsatzAnteile";
    else if (name === "Abchriftenanteil") arrayKey = "abschriftenAnteilePct";
    else if (name === "KellektionPlanVOWert") arrayKey = "kollVoorderPct";
    else if (name === "NOSPlanVOWert") arrayKey = "nosVororderPct";
    else if (name === "NOSPlanREOWert") arrayKey = "nosNachorderPct";

    if (arrayKey) {
      setDetailDiv((prev) => {
        const updatedArray = [...prev[arrayKey]];
        updatedArray[index] = cleanedValue;

        return {
          ...prev,
          [arrayKey]: updatedArray,
        };
      });
    }
  };

  const handleBlurThirdDiv = (e, index) => {
    const { name, value } = e.target;
  
    let formattedValue = value.replace(".", ",");
  
    // convert only for calculation
    const numericValue = parseFloat(
      formattedValue.replace(",", ".")
    );
  
    // console.log(numericValue); // 45,0 => 45 | 45,5 => 45.5
  
    let arrayKey = "";
  
    if (name === "Umsatzamteilin") arrayKey = "umsatzAnteile";
    else if (name === "Abchriftenanteil")
      arrayKey = "abschriftenAnteilePct";
    else if (name === "KellektionPlanVOWert")
      arrayKey = "kollVoorderPct";
    else if (name === "NOSPlanVOWert")
      arrayKey = "nosVororderPct";
    else if (name === "NOSPlanREOWert")
      arrayKey = "nosNachorderPct";
  
    if (arrayKey) {
      setDetailDiv((prev) => {
        const updatedArray = [...prev[arrayKey]];
  
        // keep original display value
        updatedArray[index] = numericValue;
  
        return {
          ...prev,
          [arrayKey]: updatedArray,
        };
      });
    }
  };

  // console.log("detail div?", detailDiv);

  const rowData = Array.isArray(detailDiv.planMonth)
  ? detailDiv.planMonth.map((_, index) => ({
      months: detailDiv.planMonth[index],
      Umsatzamteilin: detailDiv.umsatzAnteile[index] || "",
      Abchriftenanteil:
        detailDiv.abschriftenAnteilePct[index] || "",
      KellektionPlanVOWert:
        detailDiv.kollVoorderPct[index] || "",
      NOSPlanVOWert:
        detailDiv.nosVororderPct[index] || "",
      NOSPlanREOWert:
        detailDiv.nosNachorderPct[index] || "",
    }))
  : [];
  // useEffect(() => {
  //   const calculateTotals = () => {
  //     // console.log("arr??", arr);
  //     const sumArray = (arr) =>
  //       arr.reduce((acc, val) => {
  //         if (val === null || val === undefined || val === "") {
  //           return acc;
  //         }

  //         let parsed = String(val).replace(",", ".");

  //         // ignore incomplete decimal typing
  //         if (parsed === "." || parsed.endsWith(".")) {
  //           parsed = parsed.slice(0, -1);
  //         }

  //         const num = parseFloat(parsed);

  //         return acc + (isNaN(num) ? 0 : num);
  //       }, 0);

  //     const totals = {
  //       UmsatzAnteil: sumArray(detailDiv.umsatzAnteile),
  //       AbschriftenAnteil: sumArray(detailDiv.abschriftenAnteilePct),
  //       KollektionPercentagePlanWert: sumArray(detailDiv.kollVoorderPct),
  //       NOSPercentagePlanVOWert: sumArray(detailDiv.nosVororderPct),
  //       NOSPercentagePlanREOWert: sumArray(detailDiv.nosNachorderPct),
  //     };

  //     // totals.GrandTotal = Object.values(totals).reduce((a, b) => a + b, 0);

  //     setTotals(totals);

  //     Object.entries(totals).forEach(([key, value]) => {
  //       const isInvalid = value > 100;

  //       if (isInvalid && !toast.isActive(toastIds[key])) {
  //         const id = toast.error(`${key} — The total must be exactly 100.`, {
  //           position: "top-right",
  //           autoClose: 9000,
  //           style: { fontWeight: "bold" },
  //         });
  //         setToastIds((prev) => ({ ...prev, [key]: id }));
  //       } else if (!isInvalid && toastIds[key]) {
  //         toast.dismiss(toastIds[key]);
  //         setToastIds((prev) => ({ ...prev, [key]: null }));
  //       }
  //     });

  //     return totals;
  //   };

  //   calculateTotals();
  // }, [detailDiv]);

  // keyBoard navigate function
 
  useEffect(() => {
    const sumArray = (arr) =>
      arr.reduce((acc, val) => {
        if (val === null || val === undefined || val === "") {
          return acc;
        }
  
        let parsed = String(val).replace(",", ".");
  
        if (parsed === "." || parsed.endsWith(".")) {
          parsed = parsed.slice(0, -1);
        }
  
        const num = parseFloat(parsed);
  
        return acc + (isNaN(num) ? 0 : num);
      }, 0);
  
    const totals = {
      UmsatzAnteil: sumArray(detailDiv.umsatzAnteile),
      AbschriftenAnteil: sumArray(detailDiv.abschriftenAnteilePct),
      KollektionPercentagePlanWert: sumArray(detailDiv.kollVoorderPct),
      NOSPercentagePlanVOWert: sumArray(detailDiv.nosVororderPct),
      NOSPercentagePlanREOWert: sumArray(detailDiv.nosNachorderPct),
    };
  
    setTotals(totals);
  
    Object.entries(totals).forEach(([key, value]) => {
      const isInvalid = value > 100;
  
      if (isInvalid && !toast.isActive(toastIds[key])) {
        const id = toast.error(`${key} — The total must be exactly 100.`, {
          position: "top-right",
          autoClose: 9000,
          style: { fontWeight: "bold" },
        });
  
        setToastIds((prev) => ({ ...prev, [key]: id }));
      } else if (!isInvalid && toastIds[key]) {
        toast.dismiss(toastIds[key]);
  
        setToastIds((prev) => ({ ...prev, [key]: null }));
      }
    });
  }, [
    detailDiv.umsatzAnteile,
    detailDiv.abschriftenAnteilePct,
    detailDiv.kollVoorderPct,
    detailDiv.nosVororderPct,
    detailDiv.nosNachorderPct,
  ]);
 
 
  const handleTableNavigation = (e, rowIndex, colIndex) => {
    const totalRows = rowData.length;
    const totalCols = 5;

    let nextRow = rowIndex;
    let nextCol = colIndex;

    switch (e.key) {
      case "ArrowRight":
        nextCol = colIndex + 1;
        break;

      case "ArrowLeft":
        nextCol = colIndex - 1;
        break;

      case "ArrowDown":
        nextRow = rowIndex + 1;
        break;

      case "ArrowUp":
        nextRow = rowIndex - 1;
        break;

      case "Backspace":
        if (e.target.value === "") {
          nextCol = colIndex - 1;
        } else {
          return;
        }
        break;

      default:
        return;
    }

    // Boundary check
    if (
      nextRow >= 0 &&
      nextRow < totalRows &&
      nextCol >= 0 &&
      nextCol < totalCols
    ) {
      e.preventDefault();

      const nextInput = document.getElementById(`cell-${nextRow}-${nextCol}`);

      if (nextInput) {
        nextInput.focus();
      }
    }
  };

  // console.log('row data?', rowData)

  return (
    <div className="dtlContainer_main">
      <Row>
        <Col xs={12} md={6}>
          <div className="dtlContainer">
            <table className="template_table_data">
              <thead>
                <tr className="dtl_table_th">
                  <th className="" rowSpan={2}>
                    Monat
                  </th>
                  <th className="" rowSpan={2}>
                    Umsatz
                    <br />
                    Anteil in %
                  </th>
                  <th className="" rowSpan={2}>
                    Abschriften
                    <br />
                    Anteil in %
                  </th>
                  <th className="" colSpan="3">
                    Wareneingang
                  </th>
                </tr>
                <tr className="dtl_table_subheader">
                  <th>Kollektion % Plan Wert</th>
                  <th>NOS % Plan VO Wert</th>
                  <th>NOS % Plan REO Wert</th>
                </tr>
              </thead>
              <tbody className="dtl_table_body">
                {rowData?.map((data, index) => (
                  <tr key={index} className="dtl_table_body_tr">
                    <td className="dtl_months">{data.months}</td>

                    <td>
                      <input
                        id={`cell-${index}-0`}
                        name="Umsatzamteilin"
                        className="dtl_table_input"
                        onChange={(e) => getThridDiv(e, index)}
                        onBlur={(e) => handleBlurThirdDiv(e, index)}
                        onKeyDown={(e) => handleTableNavigation(e, index, 0)}
                        value={formatGermanFixedBy2(data.Umsatzamteilin)}
                        required={isRequired}
                        maxLength={6}
                        style={{
                          background: index % 2 === 0 ? "#d4ecfb" : "white",
                        }}
                        autoComplete="off"
                      />
                    </td>

                    <td>
                      <input
                        id={`cell-${index}-1`}
                        name="Abchriftenanteil"
                        className="dtl_table_input"
                        onChange={(e) => getThridDiv(e, index)}
                        onBlur={(e) => handleBlurThirdDiv(e, index)}
                        onKeyDown={(e) => handleTableNavigation(e, index, 1)}
                        value={formatGermanFixedBy2(data.Abchriftenanteil)}
                        required={isRequired}
                        maxLength={6}
                        style={{
                          background: index % 2 === 0 ? "#d4ecfb" : "white",
                        }}
                        autoComplete="off"
                      />
                    </td>

                    <td>
                      <input
                        id={`cell-${index}-2`}
                        name="KellektionPlanVOWert"
                        className="dtl_table_input"
                        onChange={(e) => getThridDiv(e, index)}
                        onBlur={(e) => handleBlurThirdDiv(e, index)}
                        onKeyDown={(e) => handleTableNavigation(e, index, 2)}
                        value={formatGermanFixedBy2(data.KellektionPlanVOWert)}
                        required={isRequired}
                        maxLength={6}
                        style={{
                          background: index % 2 === 0 ? "#d4ecfb" : "white",
                        }}
                        autoComplete="off"
                      />
                    </td>

                    <td>
                      <input
                        id={`cell-${index}-3`}
                        name="NOSPlanVOWert"
                        className="dtl_table_input"
                        onChange={(e) => getThridDiv(e, index)}
                        onBlur={(e) => handleBlurThirdDiv(e, index)}
                        onKeyDown={(e) => handleTableNavigation(e, index, 3)}
                        value={formatGermanFixedBy2(data.NOSPlanVOWert)}
                        required={isRequired}
                        maxLength={6}
                        style={{
                          background: index % 2 === 0 ? "#d4ecfb" : "white",
                        }}
                        autoComplete="off"
                      />
                    </td>

                    <td>
                      <input
                        id={`cell-${index}-4`}
                        name="NOSPlanREOWert"
                        className="dtl_table_input"
                        onChange={(e) => getThridDiv(e, index)}
                        onBlur={(e) => handleBlurThirdDiv(e, index)}
                        onKeyDown={(e) => handleTableNavigation(e, index, 4)}
                        value={formatGermanFixedBy2(data.NOSPlanREOWert)}
                        required={isRequired}
                        maxLength={6}
                        style={{
                          background: index % 2 === 0 ? "#d4ecfb" : "white",
                        }}
                        autoComplete="off"
                      />
                    </td>
                  </tr>
                ))}

                {/* Totals row */}
                <tr className="dtl_total_row">
                  <td></td>
                  <td
                    className={
                      totals.UmsatzAnteil !== 100 ? "dtlTotalClass" : ""
                    }
                  >
                    {formatGermanFixedBy2(totals.UmsatzAnteil || "") || ""}
                  </td>
                  <td
                    className={
                      totals.AbschriftenAnteil !== 100 ? "dtlTotalClass" : ""
                    }
                  >
                    {formatGermanFixedBy2(totals.AbschriftenAnteil || "") || ""}
                  </td>
                  <td
                    className={
                      totals.KollektionPercentagePlanWert !== 100
                        ? "dtlTotalClass"
                        : ""
                    }
                  >
                    {formatGermanFixedBy2(
                      totals.KollektionPercentagePlanWert || ""
                    ) || ""}
                  </td>
                  <td
                    className={
                      totals.NOSPercentagePlanVOWert !== 100
                        ? "dtlTotalClass"
                        : ""
                    }
                  >
                    {formatGermanFixedBy2(totals.NOSPercentagePlanVOWert || "") || ""}
                  </td>
                  <td
                    className={
                      totals.NOSPercentagePlanREOWert !== 100
                        ? "dtlTotalClass"
                        : ""
                    }
                  >
                    {formatGermanFixedBy2(totals.NOSPercentagePlanREOWert || "") ||
                      ""}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default DtlTemplateNew;
